import React, { Suspense, useContext } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import AuthContext from './auth/Context';

/**
 * TichHopNhung — NHÚNG một màn hình cấu hình kết nối (vốn nằm ở Kết nối & Tích hợp) vào chỗ khác, vd hộp
 * thoại "Cấu hình quảng cáo" ngay trong trang tổng quan quảng cáo của module Marketing.
 *
 * Được cấp cho script trang tuỳ biến (DynamicCustomPage) dưới tên `TichHop`:
 *     <TichHop loai="ads" />
 * Dùng CHÍNH component của trang Kết nối & Tích hợp — không có bản thứ hai để lệch nhau. Nạp trễ
 * (React.lazy) nên trang nào không dùng thì không tải thêm gì.
 */
const NAP = {
  ads: () => import('./AdAccountSettings'),
  channel: () => import('./ChannelSettings'),
  facebook: () => import('./FacebookConnect'),
  email: () => import('./EmailSettings'),
  storage: () => import('./StorageSettings'),
};
const _daNap = {};
const layComp = (loai) => (NAP[loai] ? (_daNap[loai] || (_daNap[loai] = React.lazy(NAP[loai]))) : null);

export const LOAI_TICH_HOP = Object.keys(NAP);

export default function TichHopNhung({ loai, ...rest }) {
  const context = useContext(AuthContext);
  const Comp = layComp(String(loai || ''));
  if (!Comp) {
    return <Alert severity="warning">Không có màn hình cấu hình “{String(loai || '')}”. Dùng một trong: {LOAI_TICH_HOP.join(', ')}.</Alert>;
  }
  return (
    <Suspense fallback={<Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress size={24} /></Box>}>
      <Comp context={context} {...rest} />
    </Suspense>
  );
}
